// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/occto_master_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { OcctoMasterService } from "./occto_master_service_pb";

/**
 * @generated from rpc bffuser.v1.OcctoMasterService.ListBgMasters
 */
export const listBgMasters = OcctoMasterService.method.listBgMasters;

/**
 * GetBgMaster returns the full detail of a single BG master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetBgMaster
 */
export const getBgMaster = OcctoMasterService.method.getBgMaster;

/**
 * CreateBgMaster creates a new BG master record and returns the full
 * detail of the created record. organization_id and created_by are
 * resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateBgMaster
 */
export const createBgMaster = OcctoMasterService.method.createBgMaster;

/**
 * UpdateBgMaster performs a full replacement (PUT semantics) of the BG
 * master record. bg_code, area_code, license_type, valid_from, and
 * valid_to are immutable after creation (AC-006) and are therefore
 * excluded. Uses optimistic locking via expected_updated_at.
 * organization_id and updated_by are resolved by the BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateBgMaster
 */
export const updateBgMaster = OcctoMasterService.method.updateBgMaster;

/**
 * DeleteBgMaster deletes the BG master record. Uses optimistic locking
 * via expected_updated_at. organization_id is resolved by the BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteBgMaster
 */
export const deleteBgMaster = OcctoMasterService.method.deleteBgMaster;

/**
 * @generated from rpc bffuser.v1.OcctoMasterService.ListBusinessMasters
 */
export const listBusinessMasters = OcctoMasterService.method.listBusinessMasters;

/**
 * GetBusinessMaster returns the full detail of a single business master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetBusinessMaster
 */
export const getBusinessMaster = OcctoMasterService.method.getBusinessMaster;

/**
 * CreateBusinessMaster creates a new business master record and returns
 * the full detail of the created record.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateBusinessMaster
 */
export const createBusinessMaster = OcctoMasterService.method.createBusinessMaster;

/**
 * UpdateBusinessMaster performs a full replacement (PUT semantics) of the
 * business master record. business_code is immutable after creation
 * (AC-006) and is therefore excluded. Uses optimistic locking via
 * expected_updated_at.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateBusinessMaster
 */
export const updateBusinessMaster = OcctoMasterService.method.updateBusinessMaster;

/**
 * DeleteBusinessMaster deletes the business master record. Uses optimistic
 * locking via expected_updated_at.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteBusinessMaster
 */
export const deleteBusinessMaster = OcctoMasterService.method.deleteBusinessMaster;

/**
 * ListSubmitterMasters returns the 計画提出者マスタ (submitter master)
 * list-screen projection.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListSubmitterMasters
 */
export const listSubmitterMasters = OcctoMasterService.method.listSubmitterMasters;

/**
 * GetSubmitterMaster returns the full detail of a single submitter master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetSubmitterMaster
 */
export const getSubmitterMaster = OcctoMasterService.method.getSubmitterMaster;

/**
 * CreateSubmitterMaster creates a new submitter master record and returns
 * the full detail of the created record. organization_id and created_by
 * are resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateSubmitterMaster
 */
export const createSubmitterMaster = OcctoMasterService.method.createSubmitterMaster;

/**
 * UpdateSubmitterMaster performs a full replacement (PUT semantics) of the
 * submitter master record. submitter_code, area_code, and license_type are
 * immutable after creation (AC-006) and are therefore excluded.
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateSubmitterMaster
 */
export const updateSubmitterMaster = OcctoMasterService.method.updateSubmitterMaster;

/**
 * DeleteSubmitterMaster deletes the submitter master record. Uses optimistic
 * locking via expected_updated_at. organization_id is resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteSubmitterMaster
 */
export const deleteSubmitterMaster = OcctoMasterService.method.deleteSubmitterMaster;

/**
 * ListTradingPartners returns the 取引先マスタ (trading partner master)
 * list-screen projection.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListTradingPartners
 */
export const listTradingPartners = OcctoMasterService.method.listTradingPartners;

/**
 * GetTradingPartner returns the full detail of a single trading partner.
 * organization_id is resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetTradingPartner
 */
export const getTradingPartner = OcctoMasterService.method.getTradingPartner;

/**
 * CreateTradingPartner creates a new trading partner record and returns the
 * full detail of the created record. organization_id and created_by are
 * resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateTradingPartner
 */
export const createTradingPartner = OcctoMasterService.method.createTradingPartner;

/**
 * UpdateTradingPartner performs a full replacement (PUT semantics) of the
 * trading partner record. Uses optimistic locking via expected_updated_at.
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateTradingPartner
 */
export const updateTradingPartner = OcctoMasterService.method.updateTradingPartner;

/**
 * DeleteTradingPartner deletes the trading partner record. Uses optimistic
 * locking via expected_updated_at. organization_id is resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteTradingPartner
 */
export const deleteTradingPartner = OcctoMasterService.method.deleteTradingPartner;

/**
 * GetTradingPartnerContact resolves the weekday / holiday contact points
 * of a trading partner identified by its OCCTO account code
 * (counterparty_code), for the 連絡先モーダル lazy-load
 * (plan-common.md §連絡先モーダル AC-CM-001). organization_id is resolved
 * by the BFF handler from eauth. found=false (no error) means the code is
 * not registered in the trading-partner master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetTradingPartnerContact
 */
export const getTradingPartnerContact = OcctoMasterService.method.getTradingPartnerContact;

/**
 * ListGenerationSalesMasters returns the 発電販売計画マスタ list-screen
 * projection. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListGenerationSalesMasters
 */
export const listGenerationSalesMasters = OcctoMasterService.method.listGenerationSalesMasters;

/**
 * GetGenerationSalesMaster returns the full detail of a single
 * generation-sales plan master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetGenerationSalesMaster
 */
export const getGenerationSalesMaster = OcctoMasterService.method.getGenerationSalesMaster;

/**
 * CreateGenerationSalesMaster creates a new generation-sales plan master
 * record. organization_id and created_by are resolved by the BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateGenerationSalesMaster
 */
export const createGenerationSalesMaster = OcctoMasterService.method.createGenerationSalesMaster;

/**
 * UpdateGenerationSalesMaster performs a full replacement (PUT semantics) of
 * the generation-sales plan master record. Uses optimistic locking via
 * expected_updated_at. organization_id and updated_by are resolved by the
 * BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateGenerationSalesMaster
 */
export const updateGenerationSalesMaster = OcctoMasterService.method.updateGenerationSalesMaster;

/**
 * DeleteGenerationSalesMaster deletes the generation-sales plan master record.
 * Uses optimistic locking via expected_updated_at. organization_id is
 * resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteGenerationSalesMaster
 */
export const deleteGenerationSalesMaster = OcctoMasterService.method.deleteGenerationSalesMaster;

/**
 * ListDemandProcurementMasters returns the 需要調達計画マスタ list-screen
 * projection. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListDemandProcurementMasters
 */
export const listDemandProcurementMasters = OcctoMasterService.method.listDemandProcurementMasters;

/**
 * GetDemandProcurementMaster returns the full detail of a single
 * demand-procurement plan master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandProcurementMaster
 */
export const getDemandProcurementMaster = OcctoMasterService.method.getDemandProcurementMaster;

/**
 * CreateDemandProcurementMaster creates a new demand-procurement plan master
 * record. organization_id and created_by are resolved by the BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateDemandProcurementMaster
 */
export const createDemandProcurementMaster = OcctoMasterService.method.createDemandProcurementMaster;

/**
 * UpdateDemandProcurementMaster performs a full replacement (PUT semantics)
 * of the demand-procurement plan master record. Uses optimistic locking via
 * expected_updated_at. organization_id and updated_by are resolved by the
 * BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateDemandProcurementMaster
 */
export const updateDemandProcurementMaster = OcctoMasterService.method.updateDemandProcurementMaster;

/**
 * DeleteDemandProcurementMaster deletes the demand-procurement plan master
 * record. Uses optimistic locking via expected_updated_at. organization_id
 * is resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteDemandProcurementMaster
 */
export const deleteDemandProcurementMaster = OcctoMasterService.method.deleteDemandProcurementMaster;

/**
 * ListDemandSuppressionMasters returns the 需要抑制計画マスタ list-screen
 * projection. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListDemandSuppressionMasters
 */
export const listDemandSuppressionMasters = OcctoMasterService.method.listDemandSuppressionMasters;

/**
 * GetDemandSuppressionMaster returns the full detail of a single
 * demand-suppression plan master.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandSuppressionMaster
 */
export const getDemandSuppressionMaster = OcctoMasterService.method.getDemandSuppressionMaster;

/**
 * CreateDemandSuppressionMaster creates a new demand-suppression plan master
 * record. organization_id and created_by are resolved by the BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreateDemandSuppressionMaster
 */
export const createDemandSuppressionMaster = OcctoMasterService.method.createDemandSuppressionMaster;

/**
 * UpdateDemandSuppressionMaster performs a full replacement (PUT semantics)
 * of the demand-suppression plan master record. Uses optimistic locking via
 * expected_updated_at. organization_id and updated_by are resolved by the
 * BFF handler.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdateDemandSuppressionMaster
 */
export const updateDemandSuppressionMaster = OcctoMasterService.method.updateDemandSuppressionMaster;

/**
 * DeleteDemandSuppressionMaster deletes the demand-suppression plan master
 * record. Uses optimistic locking via expected_updated_at. organization_id
 * is resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeleteDemandSuppressionMaster
 */
export const deleteDemandSuppressionMaster = OcctoMasterService.method.deleteDemandSuppressionMaster;

/**
 * GetGenerationSalesPlanMasterFormOptions returns the form-options DTO for
 * the 発電販売計画マスタ (generation-sales plan master) create/edit modal.
 * The BFF handler fans out to internalapi ListSubmitterMasters(GENERATION),
 * ListBgMasters(GENERATION_SALES_BG), and ListPlantMasters (全件) with a
 * fixed purpose and assembles the result. organization_id is resolved from
 * eauth; purpose is not exposed to the frontend.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetGenerationSalesPlanMasterFormOptions
 */
export const getGenerationSalesPlanMasterFormOptions = OcctoMasterService.method.getGenerationSalesPlanMasterFormOptions;

/**
 * GetDemandProcurementPlanMasterFormOptions returns the form-options DTO for
 * the 需要調達計画マスタ (demand-procurement plan master) create/edit modal.
 * The BFF handler fans out to internalapi ListBgMasters(DEMAND_PROCUREMENT_BG)
 * with a fixed purpose. organization_id is resolved from eauth; purpose is not
 * exposed to the frontend.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandProcurementPlanMasterFormOptions
 */
export const getDemandProcurementPlanMasterFormOptions = OcctoMasterService.method.getDemandProcurementPlanMasterFormOptions;

/**
 * GetDemandSuppressionPlanMasterFormOptions returns the form-options DTO for
 * the 需要抑制計画マスタ (demand-suppression plan master) create/edit modal.
 * The BFF handler fans out to internalapi ListSubmitterMasters(DEMAND_SUPPRESSION),
 * ListBgMasters(DEMAND_SUPPRESSION_BG), ListBgMasters(purpose absent = all),
 * and ListBusinessMasters with fixed purposes. organization_id is resolved
 * from eauth; purpose is not exposed to the frontend.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandSuppressionPlanMasterFormOptions
 */
export const getDemandSuppressionPlanMasterFormOptions = OcctoMasterService.method.getDemandSuppressionPlanMasterFormOptions;

/**
 * ListPlantMasters returns the 発電所マスタ (plant master) list.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.ListPlantMasters
 */
export const listPlantMasters = OcctoMasterService.method.listPlantMasters;

/**
 * GetPlantMaster returns the full detail of a single plant master.
 * organization_id is resolved from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.GetPlantMaster
 */
export const getPlantMaster = OcctoMasterService.method.getPlantMaster;

/**
 * CreatePlantMaster creates a new plant master record and returns the full
 * detail of the created record. organization_id and created_by are
 * resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.CreatePlantMaster
 */
export const createPlantMaster = OcctoMasterService.method.createPlantMaster;

/**
 * UpdatePlantMaster performs a full replacement (PUT semantics) of the
 * plant master record. plant_code is immutable after creation (AC-006)
 * and is therefore excluded. Uses optimistic locking via expected_updated_at.
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.UpdatePlantMaster
 */
export const updatePlantMaster = OcctoMasterService.method.updatePlantMaster;

/**
 * DeletePlantMaster deletes the plant master record. Uses optimistic locking
 * via expected_updated_at. organization_id is resolved by the BFF handler
 * from eauth.
 *
 * @generated from rpc bffuser.v1.OcctoMasterService.DeletePlantMaster
 */
export const deletePlantMaster = OcctoMasterService.method.deletePlantMaster;
